/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a302ffa3-4d78-4827-a881-dae30ed7465c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_KFXk4aBQQ",
    "aws_user_pools_web_client_id": "5t8ju3sdrehq0l0g8u655fjeb4",
    "oauth": {
        "domain": "homedecorai866ff5ec-866ff5ec-mainline.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.thehomedecorai.com/oauth",
        "redirectSignOut": "https://thehomedecorai.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "AMAZON"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "homedecoraiuserworkspaces31049-mainline",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
